import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dealer } from '@app/_models/dealer';
import { Invoice } from '@app/_models/invoice';
import { environment } from '@environments/environment';
import { catchError, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DealerStateService } from './dealer-state.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  invoices: Invoice[] = [];
  selectedInvoice: Invoice;
  constructor(
    private http: HttpClient,
    private dealerStateService: DealerStateService
  ) { }
  
  getInvoiceByDealerIdAndDealerInfo(id: string) {
    // Try to use dealer from state service first to avoid duplicate calls
    const currentDealer = this.dealerStateService.dealer();
    const currentDealerId = this.dealerStateService.currentDealerId();
    
    // If dealer is already loaded and matches, use it instead of making another call
    if (currentDealer && currentDealerId === id) {
      return forkJoin({
        dealer: of(currentDealer),
        invoice: this.http.get<Invoice[]>(`${environment.apiUrl}/invoice/getInvoiceByDealerId/${id}`)
      }).pipe(
        map(result => ({ invoice: result.invoice, dealer: result.dealer })),
        catchError(error => {
          throw error;
        })
      );
    }
    
    // Otherwise, load both dealer and invoice
    return forkJoin({
      dealer: this.http.get<Dealer>(`${environment.apiUrl}/dealer/dealerId/${id}`),
      invoice: this.http.get<Invoice[]>(`${environment.apiUrl}/invoice/getInvoiceByDealerId/${id}`)
    }).pipe(
      map(result => {
        // Update dealer state service with the loaded dealer
        this.dealerStateService.updateDealer(result.dealer);
        return { invoice: result.invoice, dealer: result.dealer };
      }),
      catchError(error => {
        throw error;
      })
    );
  }

     searchInvoice(params:any) {
      return this.http.post<{invoices:Invoice[],dealer:Dealer[]}>(`${environment.apiUrl}/invoice/searchInvoice`, params);
     }
  getInvoiceByDealerId(id:string) {
    return this.http.get<Invoice[]>(`${environment.apiUrl}/invoice/getInvoiceByDealerId/${id}`);
  }
  updateInvoice(params:any) {
    return this.http.post<Invoice>(`${environment.apiUrl}/invoice/updateInvoice/`, params)
  }
}
